<div class="card">
  <div *ngIf="loading" class="d-flex align-items-center justify-content-center p-4">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">{{ 'loading-spinner.loading' | translate }}</span>
    </div>
  </div>
  <ng-container *ngIf="!loading">
    <ng-container *ngFor="let group of attachmentGroups">
      <div *ngIf="attachmentGroups.length > 1" class="d-flex flex-row align-items-center dl-list-tr">
        <span class="dl-list-th">{{ getKindLabel(group.kind) }}</span>
      </div>
      <div *ngFor="let file of group.files" class="d-flex flex-row align-items-center dl-list-tr">
        <div>
          <i class="mr-3 text-primary" [ngClass]="getFileIcon(file)"></i>
        </div>
        <div>
          <span
            class="link-bold cursor-pointer"
            (click)="showDocument(file?.url)"
            (keydown)="showDocument(file?.url)"
            tabindex="-1"
          >
            {{ file?.name }}
          </span>
        </div>
      </div>
    </ng-container>
    <div *ngIf="!attachmentGroups.length" class="d-flex flex-row align-items-center dl-list-tr">
      <span>{{ 'product.files.empty' | translate }}</span>
    </div>
  </ng-container>
</div>
